/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createManualSubtasks} from '../api'

export const useMutationCreateManualSubtasks = createReactQueryMutationHook('createManualSubtasks', createManualSubtasks)
